import { API } from "aws-amplify";

async function createScheduleTemplate(scheduleTemplate: ScheduleTemplate): Promise<ScheduleTemplate> {
  try {
    const path: string = `/scheduleTemplate`;

    const options = {
      body: scheduleTemplate
    };

    const data = await API.post(
      'api-service',
      path,
      options
    );

    
    return data.data as ScheduleTemplate;
  } catch (error: any) {
    throw error;
  }
}

export default createScheduleTemplate;
